module.exports = __webpack_public_path__ + "img/MG-HIW-title.01e3d491.png";